import React, { useEffect } from 'react';
import { SpatialNavigation } from '@hotstar/react-spatial-navigation';
import platformApi, { Platform } from '@hotstar/platforms';

import { AppKbHandler } from '@hotstar/app-kb-handler';
import type { NextComponentType, NextPageContext } from 'next';
import PageLoadIndicator from '@hotstar/page-load-indicator';

interface StaticHSProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: NextComponentType<NextPageContext, any, any>;
  platform: Platform;
  pageProps: {};
}

const initPlatform = (platform: Platform) => {
  window.__PLATFORM__ = platformApi[platform];
  /** This non-standard property is used in xbox to figure out the mode of input using controller */
  if (window.__PLATFORM__.name === Platform.XBOX) {
    navigator.gamepadInputEmulation = 'keyboard';
  }
};

function StaticAppComp({ component: Component, pageProps, platform }: StaticHSProps) {
  const isWindow = typeof window !== 'undefined';

  useEffect(() => {
    if (isWindow) {
      initPlatform(platform);
    }

    SpatialNavigation.init({
      debug: false,
      visualDebug: false,
      throttle: 500,
      layoutDirection: 'ltr',
      isWheelSupported: window.__PLATFORM__.name === Platform.WEBOS
    });
    SpatialNavigation.setKeyMap(window.__PLATFORM__.keyMap.navigationKeys);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppKbHandler>
      <PageLoadIndicator />
      <Component {...pageProps} />
    </AppKbHandler>
  );
}

export { StaticAppComp };
export type { StaticHSProps };
